import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4h16","key":"svg-0"}],["path",{"d":"M4 20h16","key":"svg-1"}]]

const IconBaselineDensityLarge = createReactComponent('outline', 'baseline-density-large', 'BaselineDensityLarge', __iconNode);

export default IconBaselineDensityLarge;